// ############################################################################
// ## Modal ###################################################################
// ############################################################################

import $ from "jquery"

const MODAL_HTML = `
<div class="modal modal-draggable" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm modal-alert" role="document">
    <div class="modal-content">
      <div class="modal-header modal-draggable-handle">
        <div class="modal-title"></div>
      </div>
      <div class="modal-body">
        <i class="modal-icon"></i>
        <p></p>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>`;

const CLOSE_BTN_WITH_ICON_HTML = '<button type="button" class="btn btn-secondary" data-dismiss="modal"><i></i><span></span></button>';
const CLOSE_BTN_WITHOUT_ICON_HTML = '<button type="button" class="btn btn-secondary" data-dismiss="modal"></button>';

let $modal = null;
let isUncloseable = null;

function ensureModal() {
  if ($modal) return;
  $modal = $(MODAL_HTML);
  $modal.appendTo(document.body);
}

function show(opts) {
  ensureModal();
  // var onButtonClick;

  if (isUncloseable !== !!opts.uncloseable) {
    // reinit if this option changed
    $modal.modal("dispose").modal({
      backdrop: opts.uncloseable ? "static" : true,
      keyboard: !opts.uncloseable,
      show: false
    });
  }
  isUncloseable = !!opts.uncloseable;

  // $modal.find(".modal-controls [data-dismiss=modal]").toggleClass("d-none", !!opts.uncloseable);

  // classes
  if(opts.iconClassName) $modal.find(".modal-icon").show().prop("className", "modal-icon " + opts.iconClassName);
  else $modal.find(".modal-icon").hide();

  const modalClassName = opts.modalClassName || "";
  $modal.prop("className", "modal modal-draggable " + modalClassName);

  const headerClassName = opts.headerClassName || "";
  $modal.find(".modal-header").prop("className", "modal-header modal-draggable-handle " + headerClassName);

  const footerClassName = opts.footerClassName || "";
  $modal.find(".modal-footer").prop("className", "modal-footer " + footerClassName);

  // texts
  $modal.find(".modal-header [data-dismiss='modal']").attr("aria-label", opts.closeLabel);
  $modal.find(".modal-title").text(opts.title);
  $modal.find(".modal-body p")[opts.bodyHTML ? "html" : "text"](opts.body);

  // buttons
  const $footer = $modal.find(".modal-footer");
  $footer.children().remove();

  let $btn;

  if (opts.closeButton) {
    if(opts.closeButtonIcon) {
      $btn = $(CLOSE_BTN_WITH_ICON_HTML);
      $btn.find("i").prop("className", opts.closeButtonIcon);
      $btn.find("span").text(opts.closeLabel);
    } else {
      $btn = $(CLOSE_BTN_WITHOUT_ICON_HTML);
      $btn.text(opts.closeLabel);
    }

    $btn.appendTo($footer);
  }

  if(opts.buttons) {
    for (let i = 0; i < opts.buttons.length; i++) {
      const button = opts.buttons[i];

      if(button.icon) {
        $btn = $('<button type="button" class="btn" data-dismiss="modal"><i></i><span></span></button>');
        $btn.find("i").prop("className", button.icon);
        $btn.find("span").text(button.label);
      } else {
        $btn = $('<button type="button" class="btn" data-dismiss="modal"></button>');
        $btn.text(button.label);
      }

      if (button.focus) $btn.attr("data-focus", "");

      $btn.addClass(button.className)
        .click(button.action)
        .appendTo($footer);
    }
  }

  $modal.modal("show");

  /*return new Promise(function(resolve) {
   onButtonClick = resolve;
  });*/
}

export var Modal = {
  show: show,
  bind: function ($els, event, opts) {
    $($els).each(function () {
      const el = this;
      const $el = $(el);

      if ($el.data("modalBound")) return;
      $el.data("modalBound", true);

      function getMyOpts() {
        if(!(opts.buttonLabel || opts.buttonClassName || opts.buttonIcon || opts.focusButton)) {
          return {};
        } else {
          return {
            buttons: [{
              label: opts.buttonLabel,
              className: opts.buttonClassName,
              icon: opts.buttonIcon,
              focus: opts.focusButton,
              action: function () {
                let defaultPrevented = false;
                const $evt2 = $.Event(event, {
                  originalEvent: {
                    target: el,
                    button: 0,
                    stopPropagation() {
                    },
                    preventDefault() {
                      defaultPrevented = true;
                    }
                  }
                });
                $el.trigger($evt2, true);
                if (!defaultPrevented && el.tagName.toUpperCase() === 'A' && event === "click") location = el.href;
              }
            }]
          };
        }
      }

      const my_opts = Object.assign({}, opts, getMyOpts());

      $el.on(event, function (evt, bypass) {
        if (bypass) return;
        if (my_opts.if && !my_opts.if()) return;
        let my_my_opts = my_opts;
        if(typeof my_opts.body === "function") {
          my_my_opts = Object.assign({}, my_my_opts, { body: my_opts.body(this) });
        }
        show(my_my_opts);
        evt.preventDefault();
        evt.stopPropagation();
      });
    });
  }
};
